import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { GlobalVariables } from '../../constants/global-constants';

@Component({
  selector: 'app-theme-selector',
  standalone: true,
  imports: [
    MatSlideToggleModule,
    MatIconModule
  ],
  templateUrl: './theme-selector.component.html',
  styleUrl: './theme-selector.component.scss'
})
export class ThemeSelectorComponent {
  isDark = new FormControl('', []);
  lightTheme: string = GlobalVariables.lightTheme;
  darkTheme: string = GlobalVariables.darkTheme;
  isDarkTheme: boolean = false;
  currentTheme = localStorage.getItem('theme') ? localStorage.getItem('theme') : 'light-theme';
  @Output() theme = new EventEmitter<String>();
  @Output() themeSelected = new EventEmitter();

  ngOnInit(){
    this.isDarkTheme = this.currentTheme == GlobalVariables.darkTheme ? true : false;
  }

  setTheme(theme: string){
    localStorage.setItem('theme', theme);
  }

  toggle(event: any){
    if(event){
      if(event.checked){
        document.body.classList.remove(this.lightTheme);
        document.body.classList.add(this.darkTheme);
        this.setTheme(this.darkTheme);
        this.themeSelected.emit(this.darkTheme);
      }
      else{
        document.body.classList.remove(this.darkTheme);
        document.body.classList.add(this.lightTheme);
        this.setTheme(this.lightTheme);
        this.themeSelected.emit(this.lightTheme);
      }
    }
  }
}
